import React, { useEffect, useState } from 'react';
import { ssoService, SSOUser } from '../shared/ssoService';
import './AccountsDashboard.css';

const AccountsDashboard: React.FC = () => {
  const [user, setUser] = useState<SSOUser | null>(null);

  useEffect(() => {
    const loadUser = async () => {
      const currentUser = await ssoService.getCurrentUser();
      setUser(currentUser);
    };
    loadUser();
  }, []);

  const handleLogout = async () => {
    await ssoService.logout();
  };

  return (
    <div className="accounts-dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <div className="dashboard-navbar-brand">
            <img src="https://syberkey.com/images/logo.png" alt="SyberKey Logo" className="dashboard-logo-img" />
            <div className="dashboard-brand-text">
              <div className="dashboard-brand-name">
                Syber<span className="brand-yellow">Key</span>
              </div>
            </div>
            <span style={{ marginLeft: '1rem', color: 'var(--muted)', fontSize: '0.9rem' }}>• Accounts</span>
          </div>
          <div className="user-info">
            {user && (
              <span className="user-email">{user.email}</span>
            )}
            <button onClick={handleLogout} className="logout-btn">Logout</button>
          </div>
        </div>
      </header>

      <main className="dashboard-content">
        <div className="welcome-section">
          <h2>Welcome to Accounts Management</h2>
          <p>Manage your financial accounts and transactions</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">💰</div>
            <div className="stat-info">
              <h3>Total Balance</h3>
              <p className="stat-value">$125,450.00</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">📈</div>
            <div className="stat-info">
              <h3>Monthly Income</h3>
              <p className="stat-value">$8,500.00</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">📉</div>
            <div className="stat-info">
              <h3>Monthly Expenses</h3>
              <p className="stat-value">$3,200.00</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">💳</div>
            <div className="stat-info">
              <h3>Active Accounts</h3>
              <p className="stat-value">5</p>
            </div>
          </div>
        </div>

        <div className="content-section">
          <h3>Recent Transactions</h3>
          <table className="transactions-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2026-01-29</td>
                <td>Salary Deposit</td>
                <td className="amount-positive">+$8,500.00</td>
                <td><span className="status-badge success">Completed</span></td>
              </tr>
              <tr>
                <td>2026-01-28</td>
                <td>Office Supplies</td>
                <td className="amount-negative">-$245.50</td>
                <td><span className="status-badge success">Completed</span></td>
              </tr>
              <tr>
                <td>2026-01-27</td>
                <td>Utility Bill Payment</td>
                <td className="amount-negative">-$180.00</td>
                <td><span className="status-badge success">Completed</span></td>
              </tr>
              <tr>
                <td>2026-01-26</td>
                <td>Investment Return</td>
                <td className="amount-positive">+$1,200.00</td>
                <td><span className="status-badge success">Completed</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
};

export default AccountsDashboard;
